import type { RouteObject } from "react-router-dom";
import React from "react";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/login/page";
import Signup from "../pages/signup/page";
import Portal from "../pages/portal/page";
import ProtectedRoute from "../components/ProtectedRoute";
import AdminProtectedRoute from "../components/AdminProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/book",
    element: React.createElement(React.lazy(() => import("../pages/book/page"))),
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/reset-password",
    element: React.createElement(React.lazy(() => import("../pages/reset-password/page"))),
  },
  {
    path: "/portal",
    element: (
      <ProtectedRoute>
        <Portal />
      </ProtectedRoute>
    ),
  },
  {
    path: "/portal/fund",
    element: (
      <ProtectedRoute>
        {React.createElement(React.lazy(() => import("../pages/portal/fund/page")))}
      </ProtectedRoute>
    ),
  },
  {
    path: "/portal/fund/success",
    element: (
      <ProtectedRoute>
        {React.createElement(React.lazy(() => import("../pages/portal/fund/success/page")))}
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/login",
    element: React.createElement(React.lazy(() => import("../pages/admin-login/page"))),
  },
  {
    path: "/admin",
    element: (
      <AdminProtectedRoute>
        {React.createElement(React.lazy(() => import("../pages/admin/page")))}
      </AdminProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
